
export default function ($q, userMessage, error) {
  $q.notify({
    message: `<div><b>${userMessage}</b></div><div>${error.message.replace(/\n/g, '</br>')}</div>`,
    html: true,
    color: 'negative',
    icon: 'report_problem',
    actions: [{ icon: 'cancel', color: 'white' }],
    timeout: 3000
  })
}
